import React from 'react';
import styled from 'styled-components/macro';
import ScrollableAnchor from 'react-scrollable-anchor';
import { connect } from 'react-redux';
import {
  paymentTypes,
  setPaymentType,
  getPaymentType,
  getPaymentTypeIsPossible,
  deliveryTypes,
  hasSomeNoneSTypeFustageButNoAnlaeg,
} from '../../../features/commerce';
import EanForm from './EanForm';
import { Div } from '../../../components/grid';
import {
  Paragraph,
  LinkStyled,
  Hr,
  Spacer,
  Bold,
} from '../../../components/typography';
import { Table, Td } from '../../../components/tables';
import { Money, Price } from '../../../containers/commerce';
import { MoneyFormat } from '../../../components/Format';
import BucketDelivery from '../../../components/commerce/Bucket/BucketDelivery';
import OrderSubmitButton from '../../../containers/commerce/OrderSubmitButton';
import SimpleBucket from './SimpleBucket';
import ReadMore from '../../../components/ReadMore';
import { ScreenSizeDetector } from '../../../lib/helpers';
import TooltipModalLink from '../../../components/TooltipModal/TooltipModalLink';
import { hasLejeItem } from '../../../features/commerce/selectors';
import { SPECIAL_NOTICE_ENABLED } from '../../../settings';
import { BsCheckSquare, BsCreditCard, BsSquare } from '../../../components/Icons';
import AlkoholWebbannerGodkend from '../../../containers/commerce/AlkoholWebbannerGodkend';

const renderDelivery = () => <BucketDelivery />;

const TotalWrapNoStyle = ({
  children,
  ...otherProps
}) => (
  <div {...otherProps}>
    {children}
  </div>
);
const TotalWrap = styled(TotalWrapNoStyle)`
  border-right: 3px solid ${({ theme }) => theme.colors.colorGreyLight};
  border-left: 3px solid ${({ theme }) => theme.colors.colorGreyLight};
  padding: 0 15px;
`;
const BetalingWrapNoStyle = ({
  children,
  ...otherProps
}) => (
  <div {...otherProps}>
    {children}
  </div>
);
const BetalingWrap = styled(BetalingWrapNoStyle)`
  background: ${({ theme }) => theme.colors.colorGreyLight};
  padding: 0 15px;
`;
const ButtomWrapNoStyle = ({
  children,
  ...otherProps
}) => (
  <div {...otherProps}>
    {children}
  </div>
);
const ButtomWrap = styled(ButtomWrapNoStyle)`
  background: ${({ theme }) => theme.colors.colorGreyLight};
  padding: 5px 15px 15px 15px;
  margin-top: -15px;
`;
const CheckBoxComponentNoStyle = ({
  checked,
  onClick,
  children,
  ...otherProps
}) => (
  <Div
    onClick={onClick}
    {...otherProps}
  >
    <div className='icon'>{checked ? <BsCheckSquare /> : <BsSquare />}</div>
    <div>{children}</div>
  </Div>
);
const CheckBoxComponent = styled(CheckBoxComponentNoStyle)`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  padding: 5px 0;

  & > .icon {
    display: flex;
    font-size: 18px;
  }

  ${({ checked, theme }) => {
    if (checked) {
      return `
        color: ${theme.colors.colorGreen};
      `;
    }
    return `
      color: ${theme.colors.colorGreyDark};
    `;
  }}
`;

const BetalingsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 10px;
`;

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
`;

const PayContainer = ({
  possible,
  paymentType,
  chosenPaymentType,
  changePaymentType,
  children,
}) => (
  possible
    ? (
      <ScreenSizeDetector textSize={[[1199, '15px'], '16px']}>
        <CheckBoxComponent
          checked={paymentType === chosenPaymentType}
          onClick={changePaymentType(paymentType)}
          className={`payment_${paymentType}`}
        >
          {children}
          { paymentType === paymentTypes.eanInvoice && paymentType === chosenPaymentType && <EanForm />}
        </CheckBoxComponent>
      </ScreenSizeDetector>
    )
    : null
);
const ConnectedPayContainer = connect(
  (state, { paymentType }) => ({
    chosenPaymentType: getPaymentType(state),
    possible: getPaymentTypeIsPossible(state, { paymentType }),
  }),
  dispatch => ({
    changePaymentType: paymentType => () => dispatch(setPaymentType(paymentType)),
  }),
)(PayContainer);


const GodkendOrdre = ({
  totalPant,
  totalReturPant,
  totalCost,
  isDelivery,
  deliveryCost,
  hasMoms,
  deliveryType,
  hasLeje,
  hasNonSTypeAndNoAnlaeg,
}) => (
  <Div>
    <TotalWrap>
      <SimpleBucket />
      {renderDelivery({ isDelivery, deliveryCost })}
      {(!hasMoms || totalPant !== 0 || totalReturPant !== 0) && (
        <Table margin="0 0 10px 0" paddingTd="10px 0 0 0" borderTop="2px solid #999">
          <tbody>
            {totalPant !== 0 && (
              <tr>
                <Td>Pant:</Td>
                <Td textRight><Money money={totalPant} /></Td>
              </tr>
            )}
            {totalReturPant !== 0 && (
              <tr>
                <Td><LinkStyled to="/bestil/returpant">Returpant</LinkStyled>:</Td>
                <Td textRight><Money money={totalReturPant} multiplier={-1} /></Td>
              </tr>
            )}
            {!hasMoms && (
              <tr>
                <Td>Moms:</Td>
                <Td textRight><MoneyFormat onlyMoms money={totalCost} /></Td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
      <Hr bgColor="#999" />
      <Table>
        <tbody>
          <tr>
            <Td bold>I alt med moms{
              totalPant !== 0 && (
                <React.Fragment>
                  ,<br />og pant:
                </React.Fragment>
              )
            }
            </Td>
            <Td bold textRight><MoneyFormat moms money={totalCost} /></Td>
          </tr>
          <tr>
            <Td colspan="2">
              <Spacer size="10px" />
            </Td>
          </tr>
        </tbody>
      </Table>
    </TotalWrap>
    <BetalingWrap>
      <BetalingsHeader>
        <StyledIcon><BsCreditCard /></StyledIcon>
        <ScrollableAnchor id="betaling">
          <Bold>Betalingsmetode:</Bold>
        </ScrollableAnchor>
      </BetalingsHeader>
      <Div margin="15px 0">
        <ConnectedPayContainer paymentType={paymentTypes.invoice}>
          Faktura
        </ConnectedPayContainer>
        <ConnectedPayContainer paymentType={paymentTypes.eanInvoice}>
          Ean Faktura
        </ConnectedPayContainer>
        <ConnectedPayContainer paymentType={paymentTypes.card}>
          Kort / Mobilepay&nbsp;&nbsp;
          <TooltipModalLink>
            <Paragraph>
              Du reserver kun et beløb ved brug af dit kort, vi hæver kun det den endelige regning bliver på.
            </Paragraph>
            <Paragraph>
              Beløbet vil være fratrukket ubrugte fustager samt returpant.
            </Paragraph>
          </TooltipModalLink>
        </ConnectedPayContainer>
        <ConnectedPayContainer paymentType={paymentTypes.cash}>
          Betaler på lageret ved afhentning
        </ConnectedPayContainer>
      </Div>
    </BetalingWrap>
    <AlkoholWebbannerGodkend />
    <ButtomWrap>
      {!hasLeje && (
        <Div marginTop="15px">
          <LinkStyled to="/bestil/returpant">Jeg har returpant.</LinkStyled>
        </Div>
      )}
      {SPECIAL_NOTICE_ENABLED && (
        <Paragraph red marginTop="15px">
          Bryggerierne varsler prisstigninger fra 1. juli og 1. august 2022. Priserne på leveringsdagen vil være gældende. Forventet stigning 5-9%.
        </Paragraph>
      )}
      {hasNonSTypeAndNoAnlaeg && (
        <Paragraph red bold marginTop="15px" marginBottom="0px">
          Bemærk at du køber fustager med anden kobling end S-kobling, de passer ikke på anlæg der f.eks. er beregnet til Carlsberg/Tuborg fustager.
        </Paragraph>
      )}
      <OrderSubmitButton />
      <Paragraph paddingTop="10px">
        Bestillingen kan altid ændres / annulleres
      </Paragraph>
      <Paragraph bold>
        Vi accepterer:
      </Paragraph>
      <Paragraph marginBottom="0px">
        <ScreenSizeDetector width={[[400, '50px'], [991, '60px'], [1199, '50px'], '60px']}>
          <img src="/svg/mobilepay.svg" alt="MobilePay" />
          <img src="/svg/dankort.svg" alt="Dankort" />
          <img src="/svg/visa.svg" alt="Visa" />
          <img src="/svg/mastercard.svg" alt="MasterCard" />
          <img src="/svg/maestro.svg" alt="Maestro" />
        </ScreenSizeDetector>
      </Paragraph>
      <Paragraph fontSize="12px">
        Kortgebyr tillægges firma og udenlandske kort
      </Paragraph>
      {deliveryType !== deliveryTypes.delivery && (
        <Paragraph fontSize="12px">
          Ubrugte fustager, refunderes til fuld pris minus <Price varenr="641" /> pr. stk.
        </Paragraph>
      )}
      <ReadMore title="Hvad sker der efter godkendelse / betaling?">
        <Paragraph fontSize="12px">
          Efter godkendelse eller betaling modtager du en kopi af din bestilling.
          Dette er ikke en ordrebekræftelse eller en faktura.
          Giver din bestilling anledning til tvivl eller spørgsmål ringer vi dig op for at gennemgå ordren.
          Vi tilpasser ordren i telefonen, hvis nødvendigt.
        </Paragraph>
        <Paragraph fontSize="12px">
          Momsspecificeret faktura fremsendes efter arrangementet hvis du har lejet udstyr.
          Ellers fremsendes den efter levering eller afhentning af varerne.
          Vi modregner evt. returpant inden vi hæver pengene eller sender faktura.
        </Paragraph>
      </ReadMore>
    </ButtomWrap>
  </Div>
);

export default connect(
  state => ({
    hasLeje: hasLejeItem(state),
    hasNonSTypeAndNoAnlaeg: hasSomeNoneSTypeFustageButNoAnlaeg(state),
  }),
)(GodkendOrdre);
